import { FormControl } from '@angular/forms';

import { AppointmentTypes } from '@lib/core/models/visit.interface';

export interface PlanPrescriptionPayload {
  userId: string;
  prescriptions: PrescriptionDetails[];
  partnerId: string;
  locationId: string;
  doctorId?: string;
  startTime: string;
  endTime: string;
  price: number;
  source: AppointmentSource;
  eventPlace: AppointmentEventPlaceType;
}

export interface UpdatePrescriptionPlanningPayload {
  partnerId: string;
  doctorId?: string;
  locationId: string;
  startTime?: string;
  endTime?: string;
  price?: number;
  franchise?: number;
  eventPlace: AppointmentEventPlaceType;
}

export interface PrescriptionDetails {
  id: string;
  franchise: number;
}

export enum AppointmentSource {
  Manual = 'Manual',
  Suggestions = 'Suggestions',
  Slots = 'Slots',
}

export enum AppointmentEventPlaceType {
  Hospital = 'Hospital',
  Home = 'Home',
  Telemedicine = 'Telemedicine',
}

export enum CreateAppointmentModalType {
  ManualCreation = 'ManualCreation',
  BindToExisting = 'BindToExisting',
  Cancel = 'Cancel',
}

export interface CreateAppointmentControls {
  appointmentType: FormControl<AppointmentTypes>;
  appointmentName: FormControl<string>;
  prescriptionIds: FormControl<string[]>;
  partnerId: FormControl<string>;
  locationId: FormControl<string>;
  doctorId: FormControl<string | null>;
  doctorName: FormControl<string>;
  date: FormControl<Date>;
  startTime: FormControl<Date>;
  endTime: FormControl<Date>;
  eventPlace: FormControl<AppointmentEventPlaceType>;
  price: FormControl<number | null>;
}

export interface AppointmentSuggestionResponse {
  partnerId: string;
  locationId: string;
  doctorId: string;
  doctorName: string;
  locationName: string;
  description: string;
  startDate: string;
  endDate: string;
  relatedAppointmentsIds: string[];
}
